module.exports = __webpack_public_path__ + "media/images/flags/jp-4ecbd30ab2e8917f4887b7e3e8651b09.svg";